
/**
 * registration_step1_complete
 * Успешный ввод кода из смс (успешное прохождение шага 1 регистрации)
 */
export interface RegistrationStep1Complete {}

export function mapRegistrationStep1CompleteEvent(event: RegistrationStep1Complete): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'registration_step1_complete',
    event_properties: {},
  };
}
